import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PageGenericActionItem } from "./page-generic-action-item";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";

@Component({
  selector: "page-generic-action",
  template: "",
  providers: [
    {
      provide: PageGenericActionItem,
      useExisting: PageGenericActionComponent
    }
  ],
  standalone: false
})
export class PageGenericActionComponent {
  @Input()
  icon: string = "";

  @Input()
  title: string = "";

  @Input()
  disabled!: boolean;

  @Input()
  primary?: boolean;

  @Output()
  onClick: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  onClickAsync: EventEmitter<ButtonClickAsyncEvent> =
    new EventEmitter<ButtonClickAsyncEvent>();
}
